"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Hyperlink.css");
/**
 * @see HyperlinkProps
 */
var Hyperlink = /** @class */ (function (_super) {
    __extends(Hyperlink, _super);
    function Hyperlink(props) {
        var _this = _super.call(this, props) || this;
        // bind the _onClick method to the control 'this'
        _this._onClick = _this._onClick.bind(_this);
        return _this;
    }
    Hyperlink.prototype._onClick = function (event) {
        if (this.props.url === '')
            event.preventDefault();
        if (this.props.isEnabled && this.props.onClick) {
            this.props.onClick(event);
        }
    };
    Hyperlink.prototype.render = function () {
        var cssClasses = ['p-link'];
        var attrs = {};
        function customizeEnums(en) {
            var cases = {
                Xsmall: 'xs',
                Small: 'sm',
                Default: 'd',
                Medium: 'md',
                Large: 'lg',
                Xlarge: 'xl',
                Xlarge2: '2x',
                Xlarge3: '3x',
                Xlarge4: '4x',
                Xlarge5: '5x',
                Baseline: 'bl',
                Sub: 'sb',
                Super: 'sp',
                Top: 't',
                TextTop: 'tt',
                Middle: 'm',
                Bottom: 'b',
                TextBottom: 'tb',
                Initial: 'ini',
                Inherit: 'inh',
                Ellipsis: 'el',
                ForceWrap: 'fw',
                Block: 'bl',
                Inline: 'in',
                InlineBlock: 'ib'
            };
            return cases[en] ? cases[en].toLowerCase() : en.toLowerCase();
        }
        function constructClass(prop, prefix) {
            if (prop && prop !== 'None') {
                var customProp = customizeEnums(prop);
                cssClasses.push(prefix + "-" + customProp);
            }
        }
        var hasLinkStyle = this.props.buttonType !== 'None' ? false : this.props.hasLinkStyle;
        if (this.props.tooltip !== '')
            attrs['title'] = this.props.tooltip;
        if (this.props.tooltip === '' && this.props.wrapMode === 'Ellipsis')
            attrs['title'] = this.props.text;
        if (this.props.isEnabled && this.props.target && this.props.target !== 'None')
            attrs['target'] = '_' + this.props.target.toLowerCase();
        if (this.props.isEnabled && this.props.type === 'Action')
            attrs['onClick'] = this._onClick;
        var navUrl = '';
        switch (this.props.type) {
            case 'Mail':
                navUrl = 'mailto:' + this.props.url;
                break;
            case 'Phone':
                navUrl = 'tel:' + this.props.url;
                break;
            case 'Action':
                navUrl = 'javascript:void(0);';
                break;
            default:
                navUrl = this.props.url || '';
                break;
        }
        if (!React.Children.toArray(this.props.children).length)
            constructClass(this.props.size, 'p-f-sz');
        if (hasLinkStyle && this.props.isEnabled) {
            cssClasses.push('p-link-def');
            if (!React.Children.toArray(this.props.children).length)
                cssClasses.push('p-t-full-hv-primary50 p-f-w-6');
        }
        if (!React.Children.toArray(this.props.children).length && this.props.wrapMode !== 'None')
            constructClass(this.props.wrapMode, 'p-t-wr');
        if (this.props.hundredPercentHeight)
            cssClasses.push('p-height-100');
        if (this.props.displayType !== 'Inline')
            constructClass(this.props.displayType, 'p-bl');
        if (this.props.buttonType !== 'None') {
            cssClasses.push('p-link-btn', 'basic', this.props.buttonType ? this.props.buttonType.toLowerCase() : '');
        }
        if (this.props.vAlign !== 'None')
            constructClass(this.props.vAlign, 'p-t-va');
        if (this.props.tag != null)
            attrs['data-tag'] = this.props.tag;
        if (this.props.ariaLabel !== '')
            attrs['aria-label'] = this.props.ariaLabel;
        if (this.props.tabIndex !== '')
            attrs['tabIndex'] = this.props.tabIndex;
        if (this.props.hasTextShadow)
            cssClasses.push('p-t-s');
        if (this.props.ariaExpanded !== undefined)
            attrs['aria-expanded'] = this.props.ariaExpanded;
        if (!hasLinkStyle && !this.props.isEnabled) {
            cssClasses.push('is-disabled');
        }
        if (this.props.isEnabled) {
            return (React.createElement("a", __assign({ className: cssClasses.join(' '), href: navUrl }, attrs), React.Children.toArray(this.props.children).length ? this.props.children : this.props.text));
        }
        else {
            return (React.createElement("span", { className: cssClasses.join(' ') }, React.Children.toArray(this.props.children).length ? this.props.children : this.props.text));
        }
    };
    Hyperlink.defaultProps = {
        isEnabled: true,
        type: 'Url',
        text: '',
        tooltip: '',
        url: '#',
        target: 'None',
        size: 'Default',
        hasLinkStyle: true,
        hasTextShadow: false,
        wrapMode: 'None',
        hundredPercentHeight: false,
        displayType: 'Inline',
        buttonType: 'None',
        vAlign: 'None',
        tag: null,
        onClick: function () { return void 0; },
        ariaLabel: '',
        tabIndex: '',
        ariaExpanded: undefined
    };
    return Hyperlink;
}(React.Component));
exports.Hyperlink = Hyperlink;
exports.default = Hyperlink;
//# sourceMappingURL=Hyperlink.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/hyperlink/build/control/Hyperlink.js
// module id = 893
// module chunks = 0